// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #faf8ef;
  color: #776e65;
  font-size: 18px;
  line-height: 28px;
}
h1 {
  font-size: 36px;
  line-height: 46px;
}
a {
  color: #776e65;
}
a:hover {
  text-decoration: none;
}
.App {
  max-width: 480px;
  margin: 0px auto;
}
.App .header {
  display: flex;
  width: 100%;
}
.App .header > div {
  flex: 1;
}
.App .header .button {
  float: right;
  margin: 26px 0px;
}
.App .footer {
  margin: 24px 0px;
  font-weight: bold;
  text-align: center;
}
.App .nav-button:hover {
  cursor: pointer;
  transform: scale(1.1);
}
.App .nav-button.active {
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 3px;
  opacity: 1;
}
.hokum-point-boost-btn button {
  font-size: 18px;
  border-width: 5px;
}
.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
a {
  text-decoration: none;
}
#webpack-dev-server-client-overlay {
  display: none;
}
.leaderboard-shadow {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/core.less","webpack://./src/App.less"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ACHF;ADMA;EACE,eAAA;EACA,iBAAA;ACJF;ADOA;EACE,cAAA;ACLF;ADOE;EACE,qBAAA;ACLJ;AAjBA;EACE,gBAAA;EACA,gBAAA;AAmBF;AArBA;EAKI,aAAA;EACA,WAAA;AAmBJ;AAzBA;EASM,OAAA;AAmBN;AA5BA;EAaM,YAAA;EACA,gBAAA;AAkBN;AAhCA;EAmBI,gBAAA;EACA,iBAAA;EACA,kBAAA;AAgBJ;AArCA;EAyBI,eAAA;EACA,qBAAA;AAeJ;AAzCA;EA8BI,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,UAAA;AAcJ;AAVA;EACE,eAAA;EACA,iBAAA;AAYF;AANA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EACA,kBAAA;EACA,6FAAA;AAQF;AALA;EACE;IACE,0CAAA;EAOF;AACF;AALA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,yDAAA;EACA,+BAAA;AAOF;AAJA;EACE,wBAAA;EACA,yBAAA;EACA,gCAAA;AAMF;AAHA;EACE;IACE,mBAAA;EAKF;EAHA;IACE,UAAA;IACA,eAAA;EAKF;AACF;AAHA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EACA,8BAAA;EACA,UAAA;AAKF;AAFA;EACE,wBAAA;EACA,yBAAA;AAIF;AADA;EACE;;IAEE,kCAAA;EAGF;AACF;AAAA;EACE,qBAAA;AAEF;AACA;EACE,aAAA;AACF;AAEA;EACE,2CAAA;AAAF","sourcesContent":["@import \"variables.less\";\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #faf8ef;\n  color: #776e65;\n  font-size: @pixel-size * 2.25;\n  line-height: @pixel-size * 3.5;\n}\n\nh1 {\n  font-size: 4.5 * @pixel-size;\n  line-height: 5.75 * @pixel-size;\n}\n\na {\n  color: #776e65;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n","@import \"./styles/index.less\";\n\n.App {\n  max-width: @pixel-size * 60;\n  margin: @pixel-size * 0 auto;\n\n  .header {\n    display: flex;\n    width: 100%;\n\n    > div {\n      flex: 1;\n    }\n\n    .button {\n      float: right;\n      margin: @pixel-size * 3.25 @pixel-size * 0;\n    }\n  }\n\n  .footer {\n    margin: @pixel-size * 3 @pixel-size * 0;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  .nav-button:hover {\n    cursor: pointer;\n    transform: scale(1.1);\n  }\n\n  .nav-button.active {\n    text-decoration: underline;\n    text-decoration-style: solid;\n    text-decoration-thickness: 3px;\n    opacity: 1;\n  }\n}\n\n.hokum-point-boost-btn button {\n  font-size: 18px;\n  border-width: 5px;\n}\n\n\n// Loader\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n\na {\n  text-decoration: none;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n.leaderboard-shadow {\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
